import { deleteShipToApi, DeleteShipToApiParameter } from "@auer-steel/Services/DeleteCustomerService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";

type HandlerType = ApiHandler<DeleteShipToApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await deleteShipToApi(props.apiParameter);
};

export const UpdateSession: HandlerType = async props => {
    await updateSession({
        session: {
            customerWasUpdated: true,
        } as Session,
    });
};

export const LoadSession: HandlerType = props => {
    props.dispatch(loadSession());
};

export const DispatchCompleteLoadShipTo: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/CompleteLoadShipTo",
        model: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, SendDataToApi, UpdateSession, LoadSession, DispatchCompleteLoadShipTo];

const deleteShipTo = createHandlerChainRunner(chain, "DeleteShipTo");
export default deleteShipTo;
